import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const ArrowDownIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M1.66211 10.7279L10.0003 19.066M10.0003 19.066L18.3384 10.7279M10.0003 19.066L10.0003 1"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
